import { render, staticRenderFns } from "./DialogCreatePositionFromCompany.vue?vue&type=template&id=246ccb2b&scoped=true&"
import script from "./DialogCreatePositionFromCompany.vue?vue&type=script&lang=js&"
export * from "./DialogCreatePositionFromCompany.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreatePositionFromCompany.vue?vue&type=style&index=0&id=246ccb2b&lang=scss&scoped=true&"
import style1 from "./DialogCreatePositionFromCompany.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ccb2b",
  null
  
)

export default component.exports